import React from 'react';

import { flagStyles } from '../settings';

const SvgRE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4464px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgRE;
